var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5"},[_c('user-card'),_vm._v(" "),_c('members-card')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-7"},[_c('competencias-card'),_vm._v(" "),_c('power-university')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49867f85","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Pages/UserProfile.vue
// module id = S4NR
// module chunks = 4